export const tripleSingleSelectQuestions = ['tnm_t', 'tnm_n', 'tnm_m'];
